<template>
  <div class="app-container">
    <el-button
      type="primary"
      @click="addMenu(0)"
      style="margin-bottom: 5px"
      v-if="roles.includes('/notice_template/add')"
      >添加</el-button
    >
    <el-button
      type="primary"
      plain
      @click="reset()"
      style="margin-bottom: 5px; float: right"
      >重置</el-button
    >
    <el-button
      type="primary"
      @click="(screen.page = 1),  fetchData()"
      style="margin-bottom: 5px; float: right"
      >搜索</el-button
    >
    <el-select
      style="float: right; margin-right: 10px; width: 200px"
      filterable
      v-model="screen.is_manage"
      placeholder="请选择是否为管理模版"
    >
      <el-option label="全部模板" value=""></el-option>
      <el-option label="非管理模版" value="0"></el-option>
      <el-option label="管理模版" value="1"></el-option>
    </el-select>
    <el-table
      max-height="700"  v-loading="listLoading" 
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>

      <el-table-column label="模版名称" min-width="150">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.name }}</div>
        </template>
      </el-table-column>
      <el-table-column label="模版唯一标识" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.unique_num }}</span>
        </template>
      </el-table-column>
      <el-table-column label="类型" min-width="100">
        <template slot-scope="scope">
          <span>{{
            scope.row.type == 1
              ? "短信"
              : scope.row.type == 2
              ? "app"
              : scope.row.type == 3
              ? "通用"
              : ""
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="是否为管理模版" min-width="150">
        <template slot-scope="scope">
          <span>{{
            scope.row.is_manage == 0
              ? "非管理模版"
              : scope.row.is_manage == 1
              ? "管理模版"
              : ""
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" min-width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.create_time }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="操作" width="210" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="warning"
            @click="handleInfo(scope.row)"
            v-if="roles.includes('/notice_template/info')"
            >查看</el-button
          >
          <el-button
            size="mini"
            type="success"
            @click="handleEdit(scope.row)"
            v-if="roles.includes('/notice_template/edit')"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row.id)"
            v-if="roles.includes('/notice_template/del')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="800px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="150px"
        class="demo-ruleForm"
      >
        <el-form-item label="模板名称" prop="name">
          <el-input
            class="w4"
            :disabled="czType == 'see'"
            v-model="ruleForm.name"
            placeholder="请输入模板名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="模板唯一标识" prop="unique_num">
          <el-input
            class="w4"
            :disabled="czType == 'see'"
            v-model="ruleForm.unique_num"
            placeholder="请输入模板唯一标识"
          ></el-input>
        </el-form-item>
        <el-form-item label="模版类型" prop="type">
          <el-radio-group v-model="ruleForm.type" :disabled="czType == 'see'">
            <el-radio :label="1">短信通知</el-radio>
            <el-radio :label="2">app通知</el-radio>
            <el-radio :label="3">公共通知</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否为管理模版" prop="is_manage">
          <el-radio-group
            v-model="ruleForm.is_manage"
            :disabled="czType == 'see'"
          >
            <el-radio :label="1">管理模版</el-radio>
            <el-radio :label="0">非管理模版</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="模版示例内容" prop="demo">
          <el-input
            type="textarea"
            :disabled="czType == 'see'"
            v-model="ruleForm.demo"
            placeholder="【春风物业】尊敬的用户，您车牌为浙XXXX的车辆，在XXXX申请的车位已通过审核，登录小程序缴费后即可正常使用"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="czType == 'add'"
            type="primary"
            @click="submitForm('ruleForm')"
          >
            立即创建
          </el-button>
          <!-- <el-button
            v-if="czType == 'see'"
            type="primary"
            @click="czType = 'edit'"
          >
            编辑
          </el-button> -->
          <el-button
            v-if="czType == 'edit'"
            type="primary"
            @click="editForm('ruleForm')"
          >
            修改
          </el-button>
          <el-button
            v-if="czType == 'edit' || czType == 'see'"
            type="info"
            @click="drawer = false"
          >
            取消
          </el-button>
          <el-button
            v-if="czType == 'add'"
            type="info"
            @click="resetForm('ruleForm')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Editor from "@/components/Editor";
import { openPark, delImage } from "@/api/index";
import {
  noticeAdd,
  noticeEdit,
  noticeLists,
  noticeDel,
  noticeInfo,
  manufacturer_list,
  // intention_user,
} from "@/api/conf";
import { getToken } from "@/utils/auth";
export default {
  components: { Editor },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      token: getToken(),
      list: [],
      listLoading: true,
      drawer: false,
      drawerTitle: "添加",
      screen: {
        is_page: 1,
        page: 1,
        page_size: 15,
        is_manage: "",
      },
      total: 0,
      ruleForm: {},
      rules: {
        unique_num: [
          { required: true, message: "请输入模版唯一标识", trigger: "blur" },
        ],
        name: [{ required: true, message: "请输入模版名称", trigger: "blur" }],
        type: [{ required: true, message: "请选择模版类型" }],
        is_manage: [{ required: true, message: "请选择是否为管理模版" }],
        demo: [{ required: true, message: "请输入模版示例", trigger: "blur" }],
      },
      czType: "",
      ossUpload: this.$store.state.ossUpload,
    };
  },
  created() {
    // if (this.userInfo.park_id !== 0) {
    //   this.screen.park_id = this.userInfo.park_id;
    // } else {
    //   this.screen.park_id = "";
    // }
    this.fetchData();
    // this.getPark();
  },
  methods: {
    parkChange(e) {},
    formParkChange() {},
    reset() {
      this.screen = {
        is_manage: "",
        page: 1,
        page_size: 15,
        is_page: 1,
      };
      this.fetchData();
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 修改
    editForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              noticeEdit(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 查看
    handleInfo(val) {
      this.czType = "see";
      this.drawerTitle = "查看";
      this.getInfo(val.id);
      // this.drawer = true;
    },
    // 编辑
    handleEdit(val) {
      this.czType = "edit";
      this.drawerTitle = "编辑";
      // this.ruleForm = val
      this.getInfo(val.id);
      // this.drawer = true;
    },
    // 获取信息
    getInfo(id) {
      var that = this;
      noticeInfo({ id: id }).then((res) => {
        // this.domains = res.data.company_role_data
        that.ruleForm = {
          id: res.data.info.id,
          name: res.data.info.name,
          unique_num: res.data.info.unique_num,
          type: res.data.info.type,
          is_manage: res.data.info.is_manage,
          demo: res.data.info.demo,
        };
      });
      this.drawer = true;
    },
    // 删除
    handleDelete(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          noticeDel({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              noticeAdd(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    addMenu(id) {
      this.drawerTitle = "添加";
      this.czType = "add";
      this.ruleForm = {
        unique_num: "",
        name: "",
        type: 3,
        is_manage: 0,
        demo: "",
      };
      // if (this.userInfo.park_id !== 0) {
      //   this.ruleForm.park_id = this.userInfo.park_id;
      // }
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
      this.drawer = true;
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      noticeLists(this.screen).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}
.table-box {
  margin-top: 20px;
}
.video-box {
  width: 148px;
  height: 148px;
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  video {
    width: 100%;
    height: 100%;
  }
  &:hover {
    .handles {
      opacity: 1;
    }
  }
  .handles {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 3;
    cursor: pointer;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s;
    .el-icon-delete {
      font-size: 20px;
      color: #fff;
    }
  }
}
.avatar-uploaders {
  width: 80px;
  height: 80px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 90px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin: 0 10px;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}

::v-deep .el-textarea__inner {
  min-height: 100px !important;
}
</style>
